/* ============================================================
   HOME — page-specific scripts
   Loaded conditionally from layout/theme.liquid when template.name == 'index'.
   Modules: before/after slider · scroll reveal · hero video controls.
   ============================================================ */

/* ============================================================
   BEFORE / AFTER SLIDER (showcase section)
   ============================================================ */
(function(){
  const compare = document.getElementById('compare');
  if (!compare) return;
  const slider = document.getElementById('compareSlider');
  const after = document.getElementById('compareAfter');

  let dragging = false;

  function setPosition(clientX) {
    const rect = compare.getBoundingClientRect();
    let pct = ((clientX - rect.left) / rect.width) * 100;
    pct = Math.max(3, Math.min(97, pct));
    slider.style.left = pct + '%';
    after.style.clipPath = `inset(0 0 0 ${pct}%)`;
  }

  compare.addEventListener('mousedown', e => { dragging = true; setPosition(e.clientX); });
  window.addEventListener('mouseup', () => { dragging = false; });
  window.addEventListener('mousemove', e => { if (dragging) setPosition(e.clientX); });

  compare.addEventListener('touchstart', e => { dragging = true; setPosition(e.touches[0].clientX); }, {passive: true});
  window.addEventListener('touchend', () => { dragging = false; });
  window.addEventListener('touchmove', e => { if (dragging) setPosition(e.touches[0].clientX); }, {passive: true});

  // Intro animation — slight bounce
  setTimeout(() => {
    const bar = slider;
    bar.style.transition = 'left 0.9s cubic-bezier(0.22, 1, 0.36, 1)';
    after.style.transition = 'clip-path 0.9s cubic-bezier(0.22, 1, 0.36, 1)';
    setPosition(compare.getBoundingClientRect().left + compare.getBoundingClientRect().width * 0.62);
    setTimeout(() => { setPosition(compare.getBoundingClientRect().left + compare.getBoundingClientRect().width * 0.50); }, 450);
    setTimeout(() => {
      bar.style.transition = '';
      after.style.transition = '';
    }, 1400);
  }, 1200);
})();

/* ============================================================
   SCROLL REVEAL (any element with .reveal)
   ============================================================ */
(function(){
  const targets = document.querySelectorAll('.reveal');
  if (!targets.length) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });
  targets.forEach(el => io.observe(el));
})();

/* ============================================================
   HERO VIDEO — mute toggle + pause when offscreen + reduced-motion
   ============================================================ */
(function(){
  const video = document.getElementById('heroVideo');
  const btn = document.getElementById('heroMuteBtn');
  if (!video || !btn) return;

  // Respect prefers-reduced-motion
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) {
    video.removeAttribute('autoplay');
    video.pause();
  }

  // Mute toggle
  btn.addEventListener('click', () => {
    video.muted = !video.muted;
    btn.classList.toggle('is-muted', video.muted);
    btn.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar');
    if (!video.muted && video.paused) video.play().catch(() => {});
  });

  // Pause when fully out of viewport (saves battery/CPU on mobile)
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.01 });
    io.observe(video);
  }
})();
